import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=2d3bcd6e&scoped=true&"
import script from "./Profile.vue?vue&type=script&async=true&lang=js&"
export * from "./Profile.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=2d3bcd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bcd6e",
  null
  
)

export default component.exports